import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useSelector } from "react-redux";
import FlightsSearchForm from "./search/FlightsSearchForm";
import { useState } from "react";
import TourSearchForm from "./Tour/TourSearchForm";
import { generatePath, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Paths } from "../constants/Paths";
import HomeTourPackagesSection from "./Tour/HomeTourPackagesSection";
//import { searchResult } from "@/src/components/Tour/staticDatas/apiReplicateData";
import PopularPackages from "./Tour/PopularPackages";
import PopularDestinations from "./Tour/PopularDestinations";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "radix-ui";

import { slugify } from "../helpers/commonHelper";
import Offer from "./Offer";

function HomeSearch() {
  const [searchType, setSearchType] = useState("flights");
  const navigate = useNavigate();
  const { search } = useLocation(); // This gets the current "?query=params"

  const [tabValue, setTabValue] = useState("1");

  const handleTripTypeChange = (value) => {
    setTabValue(value);
  };

  const handleOpenPackage = (packageId, pkg) => {
    const title = pkg?.Package?.Title || pkg?.Title || "package";
    navigate({
      pathname: generatePath(Paths.TOUR_PACKAGE_DETAIL, {
        packageId: packageId,
        packageName: slugify(title)
      }),
      search: search // This preserves the existing search string
    });
  };
  const handleSearchTypeChange = (value) => {
    setSearchType(value);
  }
  return (
    <div className="w-full">

      <div className="bg-gradient-to-r from-[#149082] to-[#085b73] dark:from-[#111114] dark:to-[#111114]">
        <div className="container mx-auto px-4 py-8 lg:py-12 space-y-8">
          <div className="inline-flex rounded-full bg-white/20 p-1 backdrop-blur-sm">
            <button
              type="button"
              onClick={() => handleSearchTypeChange("flights")}
              className={`px-6 py-2 rounded-full text-base font-medium transition-all duration-200 ${searchType === "flights"
                ? "bg-white text-[#149082] shadow-md"
                : "text-white hover:bg-white/10"
                }`}
            >
              Flights
            </button>
            <button
              type="button"
              onClick={() => handleSearchTypeChange("tour")}
              className={`px-6 py-2 rounded-full text-base font-medium transition-all duration-200 ${searchType === "tour"
                ? "bg-white text-[#149082] shadow-md"
                : "text-white hover:bg-white/10"
                }`}
            >
              Tours
            </button>
          </div>
          {searchType === "flights" ? (
            <div>


              <h1 className="text-xl md:text-2xl lg:text-4xl text-white font-bold">
                Where Plans Take Off
              </h1>

              <Tabs
                onValueChange={handleTripTypeChange}
                defaultValue="1"
                value={tabValue}
                className="pb-2"
              >
                {/* No rounding on list itself */}
                <TabsList className="flex justify-start bg-transparent p-0 border-b border-border">
                  {/* ONE-WAY — top-left rounded */}
                  <TabsTrigger
                    value="1"
                    className="
      text-sm md:text-base px-4 py-3
      rounded-none rounded-tl-md border border-border border-b-0
      bg-muted text-muted-foreground
      data-[state=active]:bg-background
      data-[state=active]:text-foreground
      data-[state=active]:shadow-sm
    "
                  >
                    One-Way
                  </TabsTrigger>

                  {/* ROUND-TRIP — top-right rounded */}
                  <TabsTrigger
                    value="2"
                    className="
      text-sm md:text-base px-4 py-3
      rounded-none rounded-tr-md border border-border border-b-0
      bg-muted text-muted-foreground
      data-[state=active]:bg-background
      data-[state=active]:text-foreground
      data-[state=active]:shadow-sm
    "
                  >
                    Round-Trip
                  </TabsTrigger>
                </TabsList>


                {/* CONTENT BOX — bottom rounded */}
                <div className="bg-primary-foreground dark:bg-background shadow-md rounded-md overflow-hidden">
                  <TabsContent value="1" className="m-0 p-0">
                    <FlightsSearchForm fromhomepage={true} typeId="1" />
                  </TabsContent>

                  <TabsContent value="2" className="m-0 p-0">
                    <FlightsSearchForm fromhomepage={true} typeId="2" />
                  </TabsContent>
                </div>
              </Tabs>


            </div>) : (
            <div>
              <h1 className="text-xl md:text-2xl lg:text-4xl text-white font-bold">
                Tours and Trip packages
              </h1>

              <TourSearchForm
                onSearch={(payload) => {
                  navigate(
                    Paths.TOUR_SEARCH +
                    "?" +
                    new URLSearchParams(payload).toString()
                  );
                }}
              />
            </div>)}
        </div>
      </div>

      {searchType === "flights" && <Offer />}
      {/* {searchType === "tour" && ( */}
      <div className="bg-background dark:bg-background">
        <div className="container mx-auto px-4 py-8">
          <PopularDestinations
            onSelect={() => {

            }}
          />
        </div>
      </div>
      {/* this will hide destinations when search type is flights */}

      {/* {searchType === "tour" && ( */}
      <div className="bg-background dark:bg-background">
        <div className="container mx-auto px-4 py-8">
          <PopularPackages
            onOpenPackage={handleOpenPackage}
          />
        </div>
      </div>
      {/* this will hide packages when search type is flights */}
    </div>
  );
}

export default HomeSearch;
